import React from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import { mergeAreaChartOptions } from "../../pages/Compare/chartTheme";

const EPSGrowthCurrenctVsPast: React.FC<any> = ({
  data,
}): React.ReactElement => {
  const { series = [], categories = [] } = data || {};

  const chartData: any = {
    options: mergeAreaChartOptions({
      colors: ["var(--vi-accent-2)"],
      chart: {
        id: "EPSGrowthCurrentVsPast",
      },
      xaxis: {
        categories,
        labels: {
          offsetX: 5,
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -5,
        formatter: (value: string) => {
          return `${value}%`;
        },
      },
      legend: {
        showForSingleSeries: true,
      },
    }),
    chart: {
      type: "line",
    },
    series,
  };

  return (
    <div className="flex w-full flex-col p-4 vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">EPS Growth: Current-vs-Past (Quartely)</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="area"
        height={550}
      />
    </div>
  );
};

export default EPSGrowthCurrenctVsPast;
